module.exports = __webpack_public_path__ + "img/content-page-promo-bg.34f3e59.jpg";